import { render, staticRenderFns } from "./rp-sidebar.vue?vue&type=template&id=1c62cfdf"
import script from "./rp-sidebar.vue?vue&type=script&lang=js"
export * from "./rp-sidebar.vue?vue&type=script&lang=js"
import style0 from "./rp-sidebar.vue?vue&type=style&index=0&id=1c62cfdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports